import './Content.scss';

import cn from 'classnames';
import React from 'react';
import { Flipped, Flipper } from 'react-flip-toolkit';
import { useTranslation } from 'react-i18next';

import Promotions from '@/ebat/components/blocks/Cart/Promotions/Promotions';
import CartItem from '@/ebat/components/blocks/Standalone/Cart/CartItem/CartItem';

import { ContentDefaultProps, ContentPropTypes } from './Content.proptypes';

const Content = ({
  cart,
  className,
  currentItems,
  disabled,
  isLoading,
  isUpdated,
  onModify,
  onModifyLocal,
  onRemove,
  refetchCart,
}) => {
  const { t } = useTranslation();

  /**
   * Return list of paths for sort animation
   * @type {array}
   */
  const getFlipKeys = () => currentItems.map((item) => item.sku).join();

  return (
    <div className={cn('standalone-content', className)}>
      {currentItems && currentItems.length > 0 ? (
        <>
          <Promotions
            discountClasses={cart.discount_classes}
            isUpdated={isUpdated}
          />
          <Flipper className="flipper" flipKey={getFlipKeys()}>
            <ul className="standalone-cart__listing">
              {currentItems.map((item) => (
                <Flipped
                  flipId={item.sku}
                  key={`product-${item.id}-${item.sku}`}
                >
                  <li
                    key={`product-${item.id}`}
                    className="standalone-cart__item"
                  >
                    <CartItem
                      agrementFgaz={item.product?.agrement_fgaz}
                      brand={item.product?.brand}
                      cartSource={cart.source}
                      companyAvailability={item.product?.company_availability}
                      currentItems={currentItems}
                      delayQuantity={
                        item.product?.price_and_stock?.delay_quantity
                      }
                      diff={item.diff}
                      disabled={disabled}
                      discountClass={item.discount_class}
                      discountClasses={cart.discount_classes}
                      discountLabel={item.discount_label}
                      // Conflict with discountPrice in withPriceAndStock
                      discountPriceItem={item.discount_price}
                      flags={item.product?.flags}
                      hasPrice={item.product?.price_and_stock?.has_price}
                      hasStock={item.product?.price_and_stock?.has_stock}
                      id={item.id}
                      image={item.product?.image}
                      invoiceUnit={
                        item.invoice_unit ||
                        item.product?.price_and_stock?.invoice_unit
                      }
                      isDiff={item.is_diff}
                      isDiffSelected={item.is_diff_selected}
                      isLoading={isLoading}
                      isSalable={item.is_salable}
                      isSelected={item.is_selected}
                      isSubstitute={item.is_substitute}
                      lineSubtotal={!isUpdated ? item.line_subtotal : null}
                      mainSku={item.product?.main_sku}
                      manufacturerSku={item.product?.manufacturer_sku}
                      mustSubstitute={item.product?.must_substitute}
                      name={item.product?.name}
                      onModify={onModify}
                      onModifyLocal={onModifyLocal}
                      onRemove={onRemove}
                      price={item.price}
                      quantity={item.quantity}
                      quoteNumber={item.quote_number}
                      refetchCart={refetchCart}
                      salesPackaging={
                        item.product?.price_and_stock?.sales_packaging
                      }
                      saleUnit={
                        item.sale_unit ||
                        item.product?.price_and_stock?.sale_unit
                      }
                      sku={item.product?.sku || item.sku}
                      source={item.source}
                      splitPackaging={
                        item.product?.price_and_stock?.split_packaging
                      }
                      stockStatus={item.product?.price_and_stock?.stock_status}
                      stocks={item.product?.price_and_stock?.stocks}
                      substitute={item.substitute}
                      weeeAmount={item.weee_amount}
                      weeeTotalAmount={item.weee_total_amount}
                    />
                  </li>
                </Flipped>
              ))}
            </ul>
          </Flipper>
        </>
      ) : (
        <div className="standalone-cart__empty-cart" data-qa-id="empty-cart">
          {t('common:entities:cart.empty.title')}
        </div>
      )}
    </div>
  );
};

Content.defaultProps = {
  ...ContentDefaultProps,
};

Content.propTypes = {
  ...ContentPropTypes,
};

export default Content;
